import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormControl, FormLabel, TextField } from "@mui/material";
import { Box, Typography} from "@mui/material";
import { FormField, FormItem, FormMessage } from "@/app/global-components/form";

interface ConfirmFormFieldProps<T extends FieldValues> {
  name: FieldPath<T>;
  label: string;
  placeholder: string;
  description?: string;
  inputType?: string;
  formControl: Control<T>;
}

const ConfirmFormFieldView = <T extends FieldValues>({
  name,
  label,
  placeholder,
  description,
  inputType,
  formControl,
}: ConfirmFormFieldProps<T>) => {

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem>
          <Box sx={{ mb: 2 }}>
            <FormLabel
              sx={{
                color: "text.primary",
                fontWeight: 600,
                fontSize: "0.875rem",
                mb: 1,
                display: "block",
              }}
            >
              {label}
            </FormLabel>
            {description && (
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.75rem",
                  lineHeight: 1.4,
                }}
              >
                {description}
              </Typography>
            )}
          </Box>

          <FormControl fullWidth>
            <TextField
              variant="outlined"
              placeholder={placeholder}
              type={inputType || "text"}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                    borderWidth: 2,
                  },
                },
              }}
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ConfirmFormFieldView;
